module.exports = __webpack_public_path__ + "static/media/price-one.b1433bd6.png";